import { isApexTier } from "@/utils/ddragon";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import type { PlayerRank } from "../types";
import { RANK_ORDER, TIER_ORDER } from "../types";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function capitalize(str: string): string {
	if (!str) return "";
	return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function formatRank(rank: PlayerRank): string {
	const isApex = isApexTier(rank.tier);
	if (isApex) {
		return `${capitalize(rank.tier)} ${rank.leaguePoints} LP`;
	}
	if (rank.tier === "UNRANKED") {
		return capitalize(rank.tier);
	}
	return `${capitalize(rank.tier)} ${rank.rank}`;
}

/**
 * Convert a PlayerRank to a single sortable number.
 * Higher = better rank. Returns -1 for null/unranked.
 */
export function getRankScore(rank: PlayerRank | null | undefined): number {
	if (!rank || rank.tier === "UNRANKED") return -1;
	const tierIndex = TIER_ORDER.indexOf(rank.tier as (typeof TIER_ORDER)[number]);
	const divIndex = RANK_ORDER.indexOf(rank.rank as (typeof RANK_ORDER)[number]);
	return tierIndex * 10000 + divIndex * 100 + rank.leaguePoints;
}
